import { isSpotifyNet } from './constants';

export function getAccountsDomain() {
  return isSpotifyNet
    ? 'https://accounts.spotify.net'
    : 'https://accounts.spotify.com';
}
